import { baseApi } from "../baseApi";

const groupCategoryTag = "GroupCategory";

export const groupCategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addCategoriesToGroup: builder.mutation<any, { groupId: string; category_ids: number[] }>({
      query: ({ groupId, category_ids }) => ({
        url: `/gw/categories/group/${groupId}`,
        method: "POST",
        body: { category_ids },
      }),
      invalidatesTags: [groupCategoryTag, "Category"],
    }),
    removeCategoryFromGroup: builder.mutation<any, { groupId: string; categoryId: number }>({
      query: ({ groupId, categoryId }) => ({
        url: `/gw/categories/group/${groupId}/${categoryId}`,
        method: "DELETE",
      }),
      invalidatesTags: [groupCategoryTag, "Category"],
    }),
  }),
});

export const {
  useAddCategoriesToGroupMutation,
  useRemoveCategoryFromGroupMutation,
} = groupCategoryApi;
